module.exports = __webpack_public_path__ + "img/trash.842995d8.svg";